import { WhatsAppIcon } from "@/components/icons/whatsapp";
import { useLocale } from "@/features/i18n/locale-provider";
import { whatsappLink } from "@/lib/links";

/** Always reachable, never competing with the form's primary submit. */
export function WhatsAppFab({ number }: { number: string }) {
  const { t } = useLocale();

  return (
    <a
      href={whatsappLink(number)}
      target="_blank"
      rel="noreferrer"
      aria-label={t("cta.whatsapp")}
      className="fixed bottom-5 right-5 z-40 flex size-14 items-center justify-center rounded-full border border-ink/12 bg-bg text-ink no-underline shadow-[0_10px_30px_rgb(34_38_30_/_0.18)] transition-colors hover:bg-surface"
    >
      <WhatsAppIcon className="size-6" />
    </a>
  );
}
